export const user = {
  anonymousConsents: {
    dialog: {
      title: 'Consent Management',
      legalDescription:
        'We use cookies/browser storage to personalize content and improve user experience. We may also share data about your site usage with our social media partners. For more information, please see our privacy policy.',
      selectAll: 'Select All',
      clearAll: 'Clear All',
    },
    banner: {
      title: 'This site uses cookies',
      description: 'We use cookies/browser storage to personalize content and improve user experience.',
      allowAll: 'Allow All',
      viewDetails: 'View Details',
    },
  },
  checkoutLogin: {
    emailAddress: {
      label: 'Email address',
      placeholder: 'Enter email',
    },
    confirmEmail: {
      label: 'Confirm email',
      placeholder: 'Confirm email',
    },
    continue: 'Continue',
    emailIsRequired: 'Invalid email format',
    emailsMustMatch: 'Emails do not match',
  },
  authMessages: {
    signedOutSuccessfully: 'You have signed out.',
  },
  userRoles: {
    b2badmingroup: 'View account pricing, view product availability, place orders, view all reports, add new users, update user permissions, and approve pending user requests for Account Users.',
    b2bsalesrepresentant: 'View account pricing, view product availability, place orders, and view all reports.',
    b2bwebsupport: 'View account pricing, view product availability, and view all reports.',
    b2baccountpayable: 'View account pricing, view product availability, view all reports, including payment history and credit summary.',
    b2bbuyer: 'View account pricing, view product availability, place orders, and view all reports, except payment history and credit summary.',
    b2busernocheckout: 'View account pricing and product availability. Cannot place orders, view reports, or view invoices.',
    b2buseravailabilityonly: 'Check product availability only. Cannot view pricing, place orders, view reports, or view invoices.',
  },
};